export const MOBILE_HURDLE = 960
export const TABLET_HURDLE = 1120

export const breakpoints = [`${MOBILE_HURDLE}px`, `${TABLET_HURDLE}px`]
